"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainLandingWrap = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.MainLandingWrap = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 36px;

  ul {
    display: flex;
    flex-direction: column;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  section {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  padding-bottom: 12px;

  @media screen and (min-width: 1000px) {
    padding-bottom: 28px;
  }

  @media screen and (min-width: 1300px) {
    gap: 70px;
  }

  @media screen and (min-width: 1920px) {
    padding-bottom: 72px;
  }
`;
